// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="dialogHeader" id="dialogHeader">Select Schedule</h1>
        </div>
        <div class="hoa-dialog__main">
            <div style="display: table;width: 100%;border: none;overflow-y: auto;display: block;height: 450px;"
                 *ngIf="data.paymentSchedules.length > 0">
                <div style="display: table-row;" *ngFor="let paymentSchedule of data.paymentSchedules">
                    <div tid="scheduleNickname"
                         style="display:table-cell; padding-bottom:10px; padding-left:5px; width:250px">
                        {{paymentSchedule.nickname}}
                    </div>
                    <div style="display: table-cell; padding-bottom: 10px; width: 75px">
                        <button tid="select" id="select" class="Button Button--blue"
                                (click)="navigateToScheduleEdit(paymentSchedule.id)">Select
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="hoa-dialog__footer" ifOverFlowXClass="hoa-dialog__footer--overflowX">
            <button tid="okButton" id="okButton" class="Button Button--blue Button--minWidth130"
                    (click)="closeThisDialog('OK')">Cancel
            </button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;